import MainCard from '@/components/MainCard';
import React, { useEffect, useState } from "react";
import { get_gantt_chart } from "../../../utils/api";
import Icons from '@/components/third-party/Icons';
import { Typography } from 'antd';
import { useTheme } from '@/App';
import { useTranslation } from "react-i18next";

const { Title } = Typography;
const Graph = ({ batch_number }) => {
  const { t } = useTranslation();
  const { isDark } = useTheme();
  const textColor = isDark ? '#ffffff' : '#1f2937';

  const [showActual, setShowActual] = useState(true);
  const [data, setChartData] = useState({
    processSteps: [
      {
        name: "Wafer Preparation",
        batches: [
          {
            id: "1A",
            planned: { duration: 1.5, start: 1 },
            actual: { duration: 1.5, start: 1, delay: 0 },
            status: "complete",
          },
        ],
      },
      {
        name: "Caramel Cooking",
        batches: [
          {
            id: "1A",
            planned: { duration: 2, start: 2.5 },
            actual: { duration: 2.5, start: 2.5, delay: 0.5 },
            status: "complete",
          },
        ],
      },
      {
        name: "Caramel Cooling",
        batches: [
          {
            id: "1A",
            planned: { duration: 1, start: 5 },
            actual: { duration: 1, start: 5, delay: 0 },
            status: "complete",
          },
        ],
      },
      {
        name: "Chocolate Melting",
        batches: [
          {
            id: "1A",
            planned: { duration: 2, start: 6 },
            actual: { duration: 2, start: 6, delay: 0 },
            status: "complete",
          },
        ],
      },
      {
        name: "Layering (Wafer + Caramel)",
        batches: [
          {
            id: "1A",
            planned: { duration: 1.5, start: 8 },
            actual: { duration: 2, start: 8.5, delay: 0.5 },
            status: "complete",
          },
        ],
      },
      {
        name: "Chocolate Coating",
        batches: [
          {
            id: "1A",
            planned: { duration: 2, start: 10.5 },
            actual: { duration: 2.5, start: 11, delay: 0.5 },
            status: "complete",
          },
        ],
      },
      {
        name: "Cooling & Setting",
        batches: [
          {
            id: "1A",
            planned: { duration: 2, start: 13 },
            actual: { duration: 2, start: 13, delay: 0 },
            status: "complete",
          },
        ],
      },
      {
        name: "Packaging",
        batches: [
          {
            id: "1A",
            planned: { duration: 1, start: 15 },
            actual: { duration: 1.5, start: 15.5, delay: 0.5 },
            status: "complete",
          },
        ],
      },
    ],
    totalSteps: 16,
    milestones: [2, 8, 15], // Example: caramel cooked, layers assembled, packaging done
  });

  const getStatusColor = (status, isActual) => {
    const getBaseColor = (status) => {
      switch (status) {
        case "complete":
          return "#4CAF50"; // Green
        case "inProgress":
          return "#2196F3"; // Blue
        case "failed":
          return "#F44336"; // Red
        default:
          return "#D3D3D3"; // Light gray
      }
    };

    const getLightBaseColor = (status) => {
      switch (status) {
        case "complete":
          return "#A5D6A7"; // Light Green
        case "inProgress":
          return "#90CAF9"; // Light Blue
        case "failed":
          return "#FFCDD2"; // Light Red
        default:
          return "#F5F5F5"; // Very Light gray
      }
    };

    const baseColor = isActual
      ? getBaseColor(status)
      : getLightBaseColor(status);
    return baseColor;
  };

  const cellWidth = `${100 / (data.totalSteps + 1)}%`;

  const shouldDisplayProcess = (batch, timePoint, currentView) => {
    if (!batch) return false;
    const start = Math.floor(batch[currentView].start);
    return timePoint === start;
  };

  //handle Api

  const get_gantt_chart_data = async (batch_number) => {
    await get_gantt_chart({ batch_number: batch_number }, (res) => {
      if (res?.data?.status === "success") {
       // setChartData(res?.data?.data);
      } else {
        setChartData([{}]);
      }
    });
  };
  useEffect(() => {
    get_gantt_chart_data(batch_number);
  }, [batch_number]);

  return (
    <MainCard
      title={
        <div className="flex items-center gap-2">
          <Icons.BarChart3 className="w-7 h-7 text-blue-600" />
          <Title level={4} style={{ color: textColor, margin: 0, padding: 0 }}>
            {t('Gantt Chart')}
          </Title>
        </div>
      }
    >
      <div
        style={{
          padding: "1.5rem",
          backgroundColor: "white",
          borderRadius: "0.5rem",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          margin: "0 auto",
          overflowX: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1.5rem",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              color: "#1E3A8A",
            }}
          >
            Manufacturing Process Gantt Chart
          </h2>
          <div style={{ display: "flex", gap: "1rem" }}>
            <button
              onClick={() => setShowActual(false)}
              style={{
                padding: "0.5rem 1rem",
                borderRadius: "0.25rem",
                backgroundColor: !showActual ? "#2563EB" : "#E5E7EB",
                color: !showActual ? "white" : "black",
                border: "none",
                cursor: "pointer",
                transition: "all 0.2s",
                fontWeight: "500",
              }}
            >
              Planned
            </button>
            <button
              onClick={() => setShowActual(true)}
              style={{
                padding: "0.5rem 1rem",
                borderRadius: "0.25rem",
                backgroundColor: showActual ? "#2563EB" : "#E5E7EB",
                color: showActual ? "white" : "black",
                border: "none",
                cursor: "pointer",
                transition: "all 0.2s",
                fontWeight: "500",
              }}
            >
              Actual
            </button>
          </div>
        </div>

        {/* Legend */}
        <div
          style={{
            display: "flex",
            gap: "2rem",
            marginBottom: "1.5rem",
            padding: "0.75rem",
            backgroundColor: "#F8FAFC",
            borderRadius: "0.5rem",
          }}
        >
          {[
            { color: "#4CAF50", text: "Complete" },
            { color: "#2196F3", text: "In Progress" },
            { color: "#F44336", text: "Failed" },
          ].map((item, index) => (
            <div key={index} style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  display: "inline-block",
                  width: "1.25rem",
                  height: "1.25rem",
                  backgroundColor: item.color,
                  marginRight: "0.75rem",
                  borderRadius: "0.25rem",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                }}
              ></span>
              <span style={{ fontWeight: "500" }}>{item.text}</span>
            </div>
          ))}
        </div>

        {/* Gantt Chart */}
        <div style={{ position: "relative", overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: "800px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#F1F5F9" }}>
                <th
                  style={{
                    border: "1px solid #E2E8F0",
                    padding: "0.75rem",
                    textAlign: "left",
                    fontWeight: "600",
                    width: "200px",
                    position: "sticky",
                    left: 0,
                    zIndex: 1,
                  }}
                >
                  Process Steps
                </th>
                {Array.from({ length: data.totalSteps }, (_, i) => (
                  <th
                    key={i}
                    style={{
                      border: "1px solid #E2E8F0",
                      padding: "0.5rem",
                      textAlign: "center",
                      fontWeight: "500",
                      width: cellWidth,
                      minWidth: "40px",
                    }}
                  >
                    {i + 1}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {data?.processSteps?.map((step, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#F8FAFC" : "white",
                    height: "60px",
                  }}
                >
                  <td
                    style={{
                      border: "1px solid #E2E8F0",
                      padding: "0.75rem",
                      fontWeight: "500",
                      position: "sticky",
                      left: 0,
                      backgroundColor: index % 2 === 0 ? "#F8FAFC" : "white",
                      zIndex: 1,
                    }}
                  >
                    {step.name}
                  </td>
                  {Array.from({ length: data.totalSteps }, (_, i) => {
                    const timePoint = i + 1;
                    const currentView = showActual ? "actual" : "planned";

                    return (
                      <td
                        key={i}
                        style={{
                          border: "1px solid #E2E8F0",
                          padding: "0.25rem",
                          textAlign: "center",
                          fontSize: "0.75rem",
                          position: "relative",
                          backgroundColor: "transparent",
                          width: cellWidth,
                          minWidth: "40px",
                        }}
                      >
                        {step.batches.map((batch, batchIndex) => (
                          <React.Fragment key={batchIndex}>
                            {shouldDisplayProcess(
                              batch,
                              timePoint,
                              currentView
                            ) && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: `${
                                    (batch[currentView].start - 1) *
                                    (100 / data.totalSteps)
                                  }%`,
                                  transform: "translateY(-50%)",
                                  width: `${
                                    batch[currentView].duration * 100
                                  }%`,
                                  height: "40px",
                                  backgroundColor: getStatusColor(
                                    batch.status,
                                    showActual
                                  ),
                                  borderRadius: "4px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                  zIndex: 1,
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "0.75rem",
                                    whiteSpace: "nowrap",
                                    fontWeight: "500",
                                    color: "#1E293B",
                                    textAlign: "center",
                                  }}
                                >
                                  {batch.id}
                                </div>
                                <div
                                  style={{
                                    fontSize: "0.7rem",
                                    color: "#64748B",
                                    textAlign: "center",
                                  }}
                                >
                                  {showActual
                                    ? `${batch[currentView].duration?.toFixed(
                                        2
                                      )} hrs`
                                    : null}
                                  {/* {showActual && batch.actual.delay > 0 && (
                                                                        <div style={{
                                                                            color: "#DC2626",
                                                                            fontWeight: "bold",
                                                                            marginLeft: "0.25rem",
                                                                            textAlign: "center",
                                                                            fontSize: "0.7rem"
                                                                        }}>
                                                                            +{batch.actual.delay.toFixed(2)} delay
                                                                        </div>
                                                                    )} */}
                                </div>
                              </div>
                            )}
                          </React.Fragment>
                        ))}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </MainCard>
  );
};

export default Graph;
// import MainCard from '@/components/MainCard';

// import React, { useEffect, useState } from "react";

// import { get_batch_process_step } from '@/utils/api';

// const Graph = ({ batch_number }) => {
//   const [showActual, setShowActual] = useState(true);

//   const [loading, setLoading] = useState(false);

//   const [error, setError] = useState(null);

//   const [processData, setProcessData] = useState(null);

//   console.log("batch_number", batch_number);

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);

//       setError(null);

//       try {
//         get_batch_process_step(batch_number, (response) => {
//           console.log("Full API Response:", response.data);

//           const formattedData = formatProcessData(response.data);

//           setProcessData(formattedData);
//         });
//       } catch (e) {
//         setError(e);

//         console.error("Fetching data failed", e);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [batch_number]);

//   // Helper function to convert timestamp to hours since start

//   const getHoursSinceStart = (startTime) => {
//     const startDate = new Date(startTime);

//     const startOfDay = new Date(
//       startDate.getFullYear(),
//       startDate.getMonth(),
//       startDate.getDate()
//     );

//     return (startDate - startOfDay) / (1000 * 60 * 60) + 1;
//   };

//   // Function to format the API response data

//   const formatProcessData = (rawData) => {
//     console.log("rawData in formatProcessData:", rawData);

//     if (
//       !rawData ||
//       !rawData.data ||
//       !rawData.data.processSteps ||
//       rawData.data.processSteps.length === 0
//     ) {
//       console.error("No process steps found in data", rawData);

//       return null;
//     }

//     return {
//       processSteps: rawData.data.processSteps.map((step) => ({
//         name: step.name,

//         batches: step.batches.map((batch) => {
//           const plannedDurationInMinutes = parseFloat(
//             batch.planned.duration || "0"
//           );

//           const plannedDurationInHours = plannedDurationInMinutes / 60; // Convert minutes to hours

//           // Default planned start to 1 for all batches to ensure display

//           const plannedStart = 1;

//           const actualStart = batch.actual.start
//             ? getHoursSinceStart(batch.actual.start)
//             : null;

//           const actualDuration = parseFloat(batch.actual.duration || "0") / 60;

//           const actualEnd =
//             actualStart !== null ? actualStart + actualDuration : null;

//           return {
//             id: batch.id.toString(),

//             planned: {
//               start: plannedStart, // Use default planned start of 1

//               duration: plannedDurationInMinutes, // Keep planned duration in minutes

//               end: plannedStart + plannedDurationInHours,
//             },

//             actual: {
//               start: actualStart,

//               duration: actualDuration,

//               end: actualEnd,

//               delay: parseFloat(batch.actual.delay || "0") / 60,
//             },

//             status: batch.status,
//           };
//         }),
//       })),

//       totalSteps: 48, // Adjust this based on your requirements

//       milestones: rawData.data.milestones || [],
//     };
//   };

//   // Render function if no data is available

//   if (loading) return <div>Loading...</div>;

//   if (error) return <div>Error loading data: {error.message}</div>;

//   if (!processData) {
//     return <div>No process data available</div>;
//   }

//   const getStatusColor = (status, isActual) => {
//     const getBaseColor = (status) => {
//       switch (status) {
//         case "complete":
//           return "#4CAF50"; // Green

//         case "running":
//           return "#2196F3"; // Blue

//         case "failed":
//           return "#F44336"; // Red

//         default:
//           return "#D3D3D3"; // Light gray
//       }
//     };

//     const getLightBaseColor = (status) => {
//       switch (status) {
//         case "complete":
//           return "#A5D6A7"; // Light Green

//         case "running":
//           return "#90CAF9"; // Light Blue

//         case "failed":
//           return "#FFCDD2"; // Light Red

//         default:
//           return "#F5F5F5"; // Very Light gray
//       }
//     };

//     const baseColor = isActual
//       ? getBaseColor(status)
//       : getLightBaseColor(status);

//     return baseColor;
//   };

//   const cellWidth = `${100 / (processData.totalSteps + 1)}%`;

//   const shouldDisplayProcess = (batch, timePoint, currentView) => {
//     if (!batch) return false;

//     const start = Math.floor(batch[currentView].start);

//     return timePoint === start;
//   };

//   return (
//     <MainCard>
//       <div
//         style={{
//           padding: "1.5rem",

//           backgroundColor: "white",

//           borderRadius: "0.5rem",

//           boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",

//           margin: "0 auto",

//           overflowX: "auto",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",

//             justifyContent: "space-between",

//             alignItems: "center",

//             marginBottom: "1.5rem",
//           }}
//         >
//           <h2
//             style={{
//               fontSize: "1.5rem",

//               fontWeight: "bold",

//               color: "#1E3A8A",
//             }}
//           >
//             Manufacturing Process Gantt Chart
//           </h2>
//           <div style={{ display: "flex", gap: "1rem" }}>
//             <button
//               onClick={() => setShowActual(false)}
//               style={{
//                 padding: "0.5rem 1rem",

//                 borderRadius: "0.25rem",

//                 backgroundColor: !showActual ? "#2563EB" : "#E5E7EB",

//                 color: !showActual ? "white" : "black",

//                 border: "none",

//                 cursor: "pointer",

//                 transition: "all 0.2s",

//                 fontWeight: "500",
//               }}
//             >
//               Planned
//             </button>
//             <button
//               onClick={() => setShowActual(true)}
//               style={{
//                 padding: "0.5rem 1rem",

//                 borderRadius: "0.25rem",

//                 backgroundColor: showActual ? "#2563EB" : "#E5E7EB",

//                 color: showActual ? "white" : "black",

//                 border: "none",

//                 cursor: "pointer",

//                 transition: "all 0.2s",

//                 fontWeight: "500",
//               }}
//             >
//               Actual
//             </button>
//           </div>
//         </div>

//         {/* Legend */}
//         <div
//           style={{
//             display: "flex",

//             gap: "2rem",

//             marginBottom: "1.5rem",

//             padding: "0.75rem",

//             backgroundColor: "#F8FAFC",

//             borderRadius: "0.5rem",
//           }}
//         >
//           {[
//             { color: "#4CAF50", text: "Complete" },

//             { color: "#2196F3", text: "In Progress" },

//             { color: "#F44336", text: "Failed" },
//           ].map((item, index) => (
//             <div key={index} style={{ display: "flex", alignItems: "center" }}>
//               <span
//                 style={{
//                   display: "inline-block",

//                   width: "1.25rem",

//                   height: "1.25rem",

//                   backgroundColor: item.color,

//                   marginRight: "0.75rem",

//                   borderRadius: "0.25rem",

//                   boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//                 }}
//               ></span>
//               <span style={{ fontWeight: "500" }}>{item.text}</span>
//             </div>
//           ))}
//         </div>

//         {/* Gantt Chart */}
//         <div style={{ position: "relative", overflowX: "auto" }}>
//           <table
//             style={{
//               width: "100%",

//               borderCollapse: "collapse",

//               minWidth: "800px",
//             }}
//           >
//             <thead>
//               <tr style={{ backgroundColor: "#F1F5F9" }}>
//                 <th
//                   style={{
//                     border: "1px solid #E2E8F0",

//                     padding: "0.75rem",

//                     textAlign: "left",

//                     fontWeight: "600",

//                     width: "200px",

//                     position: "sticky",

//                     left: 0,

//                     zIndex: 1,
//                   }}
//                 >
//                   Process Steps
//                 </th>

//                 {Array.from({ length: processData.totalSteps }, (_, i) => (
//                   <th
//                     key={i}
//                     style={{
//                       border: "1px solid #E2E8F0",

//                       padding: "0.5rem",

//                       textAlign: "center",

//                       fontWeight: "500",

//                       width: cellWidth,

//                       minWidth: "40px",
//                     }}
//                   >
//                     {i + 1}
//                   </th>
//                 ))}
//               </tr>
//             </thead>

//             <tbody>
//               {processData.processSteps.map((step, index) => (

//                 <tr
//                   key={index}
//                   style={{
//                     backgroundColor: index % 2 === 0 ? "#F8FAFC" : "white",
//                     height: "60px",
//                   }}
//                 >
//                   <td
//                     style={{
//                       border: "1px solid #E2E8F0",

//                       padding: "0.75rem",

//                       fontWeight: "500",

//                       position: "sticky",

//                       left: 0,

//                       backgroundColor: index % 2 === 0 ? "#F8FAFC" : "white",

//                       zIndex: 1,
//                     }}
//                   >
//                     {step.name}
//                   </td>

//                   {Array.from({ length: processData.totalSteps }, (_, i) => {
//                     const timePoint = i + 1;

//                     const currentView = showActual ? "actual" : "planned";

//                     return (
//                       <td
//                         key={i}
//                         style={{
//                           border: "1px solid #E2E8F0",

//                           padding: "0.25rem",

//                           textAlign: "center",

//                           fontSize: "0.75rem",

//                           position: "relative",

//                           backgroundColor: "transparent",

//                           width: cellWidth,

//                           minWidth: "40px",
//                         }}
//                       >
//                         {step.batches.map((batch, batchIndex) => (
//                           <React.Fragment key={batchIndex}>
//                             {shouldDisplayProcess(
//                               batch,
//                               timePoint,
//                               currentView
//                             ) && (
//                               <div
//                                 style={{
//                                   position: "absolute",

//                                   top: "50%",

//                                   left: `${
//                                     (batch[currentView].start - 1) *
//                                     (100 / 80)
//                                   }%`,

//                                   transform: "translateY(-50%)",

//                                   width: `${
//                                     batch[currentView].duration * 100
//                                   }%`,

//                                   height: "40px",

//                                   backgroundColor: getStatusColor(
//                                     batch.status,
//                                     showActual
//                                   ),

//                                   borderRadius: "4px",

//                                   display: "flex",

//                                   flexDirection: "column",

//                                   justifyContent: "center",

//                                   alignItems: "center",

//                                   boxShadow: "0 1px 3px rgba(0,0,0,0.1)",

//                                   zIndex: 1,
//                                 }}
//                               >
//                                 <div
//                                   style={{
//                                     fontSize: "0.75rem",

//                                     whiteSpace: "nowrap",

//                                     fontWeight: "500",

//                                     color: "#1E293B",

//                                     textAlign: "center",
//                                   }}
//                                 >
//                                   {batch.id}
//                                 </div>
//                                 <div
//                                   style={{
//                                     fontSize: "0.7rem",

//                                     color: "#64748B",

//                                     textAlign: "center",
//                                   }}
//                                 >
//                                   {showActual
//                                     ? `${batch[currentView].duration.toFixed(
//                                         2
//                                       )} hrs`
//                                     : null}

//                                   {showActual && batch.actual.delay > 0 && (
//                                     <div
//                                       style={{
//                                         color: "#DC2626",

//                                         fontWeight: "bold",

//                                         marginLeft: "0.25rem",

//                                         textAlign: "center",

//                                         fontSize: "0.7rem",
//                                       }}
//                                     >
//                                       +{batch.actual.delay.toFixed(2)} delay
//                                     </div>
//                                   )}
//                                 </div>
//                               </div>
//                             )}
//                           </React.Fragment>
//                         ))}
//                       </td>
//                     );
//                   })}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </MainCard>
//   );
// };

// export default Graph;
